import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, impressaoGeraSenha } from './types';

export const INITIAL_STATE: impressaoGeraSenha = {
	status: 0,
	data: { arquivoPDF: '' },
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): impressaoGeraSenha {
	return produce(state, draft => {
		switch (action.type) {
			case Types.IMPRESSAO_GERA_SENHA_REQUEST: {
				break;
			}

			case Types.IMPRESSAO_GERA_SENHA_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.IMPRESSAO_GERA_SENHA_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.IMPRESSAO_SENHA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
